import { render, staticRenderFns } from "./IndirectTax.vue?vue&type=template&id=1bd6a07b"
import script from "./IndirectTax.vue?vue&type=script&lang=js"
export * from "./IndirectTax.vue?vue&type=script&lang=js"
import style0 from "./IndirectTax.vue?vue&type=style&index=0&id=1bd6a07b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports